import { requestV2 } from '@/utils/request'
import { type UserListData } from './types'
import { user } from './api'

/**
 * 用户列表
 * @see https://api.admin.internal.taqu.cn/docs/api/api-1ep627jeh7er6
 * @returns
 */
export const getUserList = async () => {
  return requestV2<UserListData>(user.list)
}
